import { render } from "./AuthorRec.vue?vue&type=template&id=224da89e&scoped=true"
import script from "./AuthorRec.vue?vue&type=script&lang=js"
export * from "./AuthorRec.vue?vue&type=script&lang=js"

import "./AuthorRec.vue?vue&type=style&index=0&id=224da89e&lang=scss&scoped=true"

import exportComponent from "D:\\cm_zhitu\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224da89e"]])

export default __exports__